// i18n configuration — only FR is bundled eagerly; EN and CA are split into their own chunks
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./locales/fr.json";

const resources = {
  fr: { translation: fr },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr",
    lng: "fr",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

const loaders: Record<string, () => Promise<{ default: Record<string, unknown> }>> = {
  en: () => import("./locales/en.json"),
  ca: () => import("./locales/ca.json"),
};

export async function loadLanguage(lang: string): Promise<void> {
  if (lang === "fr") return;
  if (i18n.hasResourceBundle(lang, "translation")) return;
  const loader = loaders[lang];
  if (!loader) return;
  const mod = await loader();
  i18n.addResourceBundle(lang, "translation", mod.default);
}

export default i18n;
